module.exports = __webpack_public_path__ + "img/884cdd398e5b906e4ab34e3455b0611.09ac70d6.jpg";